var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { AVAILABLE_STAFF_RESET_ACTION_TYPE, AVAILABLE_STAFF_FETCH_START_ACTION_TYPE, AVAILABLE_STAFF_FETCH_SUCCESS_ACTION_TYPE, AVAILABLE_STAFF_ERROR_ACTION_TYPE, AVAILABLE_STAFF_UNAVAILABLE_START_ACTION_TYPE, AVAILABLE_STAFF_UNAVAILABLE_SUCCESS_ACTION_TYPE, } from "./AvailableStaffActionsTypes";
import { showError } from "@spike/notifications-action";
import { convertAvailableStaff } from "./AvailableStaffConverter";
import { convertUnavailableStaff } from "./AvailableStaffConverter";
var availableStaffUrl = "/booking/staff_available";
var availabilityStaffUnavailable = "/staff/unavailable";
var isLastUnavailableFetch = function (requestToken, state) {
    return state.lastRequest.unavailable === requestToken;
};
export var fetchAvailableStaffThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart(appointmentId));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(availableStaffUrl, "/").concat(appointmentId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSucces(appointmentId, response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!axios.isCancel(apiError_1)) {
                        dispatch(error());
                        dispatch(showError("Error fetching available staff."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchUnavailableStaffThunk = function (apiClientWrapper, serviceId, bookingDate, slot) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestToken, marketplaceId, locationId, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestToken = apiClientWrapper.uuid();
                    dispatch(fetchStaffUnavaliableStart(requestToken));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    locationId = apiClientWrapper.marketplace.basics.address.id;
                    url = "".concat(availabilityStaffUnavailable, "?marketplace_id=").concat(marketplaceId, "&address_id=").concat(locationId, "&service_id=").concat(serviceId, "&booking_date=").concat(bookingDate, "&slot=").concat(slot);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastUnavailableFetch(requestToken, getState().availableStaff) && dispatch(fetchStaffUnavaliableSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError("Error fetching unavailable staff."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return { type: AVAILABLE_STAFF_RESET_ACTION_TYPE };
};
var fetchStart = function (appointmentId) {
    return {
        type: AVAILABLE_STAFF_FETCH_START_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
        },
    };
};
var fetchSucces = function (appointmentId, dtos) {
    return {
        type: AVAILABLE_STAFF_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
            availableStaff: dtos.map(function (dto) { return convertAvailableStaff(dto); }),
        },
    };
};
var fetchStaffUnavaliableStart = function (requestToken) {
    return {
        type: AVAILABLE_STAFF_UNAVAILABLE_START_ACTION_TYPE,
        payload: {
            requestToken: requestToken
        }
    };
};
var fetchStaffUnavaliableSuccess = function (dtos) {
    return {
        type: AVAILABLE_STAFF_UNAVAILABLE_SUCCESS_ACTION_TYPE,
        payload: {
            staff: dtos.map(function (dto) { return convertUnavailableStaff(dto); }),
        },
    };
};
var error = function () {
    return {
        type: AVAILABLE_STAFF_ERROR_ACTION_TYPE,
    };
};
